import React from "react";
import CampaignForm from "../CampaignForm";

const AddCampaign = () => {
  return <CampaignForm isEdit={false} />;
};

export default AddCampaign;
